import { type EmbeddedVideosFiltersEnum } from "features/Library/EmbeddedVideos/types/models";
import React, { type FC } from "react";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getEmbeddedVideosFilters } from "./embeddedVideosFiltersUtils";

export interface EmbeddedVideosFilterFormProps extends FilterFormPropsBase<EmbeddedVideosFiltersEnum> {
  disableDateFilters: boolean;
}

const EmbeddedVideosFilterForm: FC<EmbeddedVideosFilterFormProps> = ({
  filterOptions,
  filter,
  updateFilter,
  disableDateFilters,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getEmbeddedVideosFilters(true, disableDateFilters)}
  />
);

export default EmbeddedVideosFilterForm;
